/**
 * Accessibility utilities — keyboard interaction helpers.
 */

/** Returns a keyDown handler that calls callback on Enter or Space. */
export const onActivateKey = (callback) => (e) => {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    callback();
  }
};
